import React from 'react';
import { get } from 'lodash';

const PersonalInformationTeaser = ({ profile, user }) => {
  return (
    <div className="flex flex-col space-y-3">
      <div className="flex space-x-2 items-center">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">First Name</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(profile, 'attributes.first_name')}</span></div>
      </div>
      <div className="flex space-x-2 items-center ">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">Middle Name</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(profile, 'attributes.middle_name') || '-'}</span></div>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">Last Name</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(profile, 'attributes.last_name')}</span></div>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">Extension Name</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(profile, 'attributes.extension_name') || '-'}</span></div>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">Email</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(user, 'attributes.email')}</span></div>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="w-4/12 xl:w-1/4 text-sm text-gray-600">Mobile Number</div>
        <div className=""><span className="mr-3">:</span><span className="text-sm font-medium">{get(profile, 'attributes.mobile_number')}</span></div>
      </div>
    </div>   
  )
}

export default PersonalInformationTeaser